module.exports = __webpack_public_path__ + "static/media/projects_image.530b79e4.svg";